module.exports = __webpack_public_path__ + "static/media/live26_02_22.c63827e7.jpg";